import { initializedPromise } from "../../../utils/PromiseUtils";
import { createResourceUrl } from "../../../utils/resourceUtils";
import scriptLoader from "../../../utils/scriptLoader";
const initializationCheckTimes = 20;
const intervalInMs = 1000;
function loadTransmitSDK(ivaWebUrl, successCallback, failureCallback) {
    const scriptLoads = [];
    if (!window.XmSdk || !window.xmui) {
        scriptLoads.push(scriptLoader(createResourceUrl(ivaWebUrl, 'transmit-sdk.js'), false, false));
        scriptLoads.push(initializedPromise(() => !!(window.XmSdk && window.xmui), "Transmit SDK initialization error", intervalInMs, initializationCheckTimes));
    }
    if (typeof window.$ !== "function") {
        scriptLoads.push(scriptLoader(createResourceUrl(ivaWebUrl, 'jquery-3.5.1.min.js')));
    }
    Promise.all(scriptLoads)
        .then(() => scriptLoader(createResourceUrl(ivaWebUrl, 'iva-transmit-sdk.js'), false, true))
        .then(() => initializedPromise(() => window.IGLOO && typeof window.IGLOO.getBlackbox === "function", "Blackbox initialization error", intervalInMs, initializationCheckTimes))
        .then(successCallback)
        .catch(failureCallback);
}
export default loadTransmitSDK;
